import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  Box,
  Typography,
  AccordionDetails,
  IconButton,
  Tooltip,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { theme } from "../../../../styles";
import { RecortesProjetoList } from "../recortes-do-projeto/recortes-projeto-list";
import { useAppSelector } from "../../../../hooks/store-hooks";
import { useRecortesExtracaoService } from "../../../../../use-cases/geo-veles";
import { useLayoutRecorteExtracaoService } from "../../../../../use-cases/geo-veles/layout-recortes";

export const LayoutRecortes = () => {
  const [expanded, setExpanded] = useState<boolean>(true);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const { recorteExtracao } = useAppSelector((state) => state.recorteExtracao);
  const { layoutRecorteSelecionado } = useAppSelector(
    (state) => state.layoutRecorte
  );

  const { resetRecorteExtracao, setRecorteExtracao } =
    useRecortesExtracaoService();
  const { resetLayoutSelecionado, setEditLayoutRecorteFormOpen } =
    useLayoutRecorteExtracaoService();

  useEffect(() => {
    if (!recorteExtracao) setRecorteExtracao();
  }, [setRecorteExtracao]);

  const handleToggleExpand = () => {
    setExpanded(!expanded);
  };

  const handleConfirmDelete = () => {
    setOpenConfirmDialog(true);
  };

  const handleDelete = () => {
    resetLayoutSelecionado();
    resetRecorteExtracao();
    setRecorteExtracao();
    setOpenConfirmDialog(false);
  };

  return (
    <>
      <Accordion
        defaultExpanded
        expanded={expanded}
        sx={{
          my: 2,
          backgroundColor:
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={handleToggleExpand}
          aria-controls="layout-recortes-content"
          id="layout-recortes-header"
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            position: "relative",
            "& .MuiAccordionSummary-content": {
              alignItems: "center",
            },
          }}
        >
          <Box sx={{ width: "100%", display: "flex", alignItems: "center" }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", flexGrow: 1, textAlign: "center" }}
            >
              Recortes
            </Typography>

            <Box sx={{ position: "absolute", right: "70px" }}>
              <Tooltip title="Editar layout" placement="top" arrow>
                <IconButton
                  aria-label="editar-layout"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditLayoutRecorteFormOpen({
                      open: true,
                      layoutSelecionado: layoutRecorteSelecionado!,
                    });
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            <Box sx={{ position: "absolute", right: "40px" }}>
              <Tooltip title="Excluir layout" placement="top" arrow>
                <IconButton
                  aria-label="excluir-layout"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleConfirmDelete();
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </AccordionSummary>

        <AccordionDetails>
          <Box
            sx={{
              maxHeight: "70vh",
              overflowY: "auto",
              padding: 1,
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: theme.palette.primary.main,
                borderRadius: "3px",
              },
            }}
          >
            {recorteExtracao?.Recortes?.length > 0 && (
              <RecortesProjetoList
                temRecorteExtracao={recorteExtracao}
                modoSomenteLeitura={false}
              />
            )}
          </Box>
        </AccordionDetails>
      </Accordion>

      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
      >
        <DialogTitle>Confirmar exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja remover o layout{" "}
            <strong>{layoutRecorteSelecionado?.NomeLayout}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleDelete}
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              "&:hover": { backgroundColor: theme.palette.primary.dark },
            }}
          >
            Excluir Layout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
